import src from "IMAGE";
export default { src, width: 301, height: 88, blurWidth: 0, blurHeight: 0};
